// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedLanguageProficiency {
  A1: {"enum_constant":"A1","order":1};
  A2: {"enum_constant":"A2","order":2};
  B1: {"enum_constant":"B1","order":3};
  B2: {"enum_constant":"B2","order":4};
  C1: {"enum_constant":"C1","order":5};
  C2: {"enum_constant":"C2","order":6};
  Native: {"enum_constant":"Native","order":7};
}

export type LanguageProficiencyId = keyof IParsedLanguageProficiency;
export type LanguageProficiencyData = IParsedLanguageProficiency[LanguageProficiencyId];
const data: LanguageProficiencyData[] = [{"enum_constant":"A1","order":1},{"enum_constant":"A2","order":2},{"enum_constant":"B1","order":3},{"enum_constant":"B2","order":4},{"enum_constant":"C1","order":5},{"enum_constant":"C2","order":6},{"enum_constant":"Native","order":7}];
export default data;
